var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-list',{attrs:{"loading":_vm.loading,"finished":_vm.finished,"finished-text":"没有更多了"},on:{"load":_vm.onLoad}},_vm._l((_vm.list),function(item){return _c('van-cell',{key:item,attrs:{"title":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }